export default class ArrayService {
  constructor() {}

  static sortBy(array: any[], field: string, direction = "asc"): any[] {
    return direction === "asc"
      ? array.sort((a, b) => (a[field] > b[field] ? 1 : -1))
      : array.sort((a, b) => (a[field] < b[field] ? 1 : -1));
  }
}
